<div class="content">
  <div class="preview">
    <pf-upsell-preview [data]="previewParams" [minutes]="previewParams?.timer" class="h-100"></pf-upsell-preview>
  </div>
  <div class="controls" [formGroup]="form" #formRef pfScrollInvalidInput [scrollContainer]="'.controls'">
    <!-- Display Rule -->
    <div class="config">
      <div class="config-head _hoverable"
            [class._closed]="!sectionOpen.placement"
            (click)="sectionOpen.placement = !sectionOpen.placement">
        <one-icon class="mr-2" name="chevron-down" [class._rotated]="sectionOpen.placement"></one-icon>
        {{ 'upsell_page.builder.design_display_rule' | transloco }}
      </div>

      <div class="config-body" [@expandCollapse]="sectionOpen.placement">
        <div *ngIf="sectionOpen.placement">
          <div class="config-control" *ngIf="form.get('placement'); let control">
            <label>{{ 'upsell_page.builder.design_show_upsell_page' | transloco }}</label>
            <ng-select
              bindValue="value"
              bindLabel="label"
              [clearable]="false"
              class="h-46"
              formControlName="placement"
              [items]="placementOptions"
            ></ng-select>
            <small>
              {{ 'upsell_page.builder.design_flow_checkout' | transloco }}
              <span
                matTooltip="{{ 'upsell_page.builder.tooltip_one_click' | transloco }}"
                matTooltipClass="Tooltip-Box"
                matTooltipPosition="above"
                class="Tooltip-Dots">
                <strong>{{ 'upsell_page.builder.design_flow_one_page' | transloco }}</strong>
              </span>
              {{ 'upsell_page.builder.design_flow_thank_you' | transloco }}
            </small>
          </div>
        </div>
      </div>
    </div>

    <!-- Language Selector -->
    <div class="config">
      <div class="config-head _hoverable"
            [class._closed]="!sectionOpen.language"
            (click)="sectionOpen.language = !sectionOpen.language">
        <one-icon class="mr-2" name="chevron-down" [class._rotated]="sectionOpen.language"></one-icon>
        <div class="d-flex aligh-items-center justify-content-between w-100">
          {{ 'upsell_page.builder.design_system_text' | transloco }}
          <span class="Tooltip"
            matTooltipClass="Tooltip-Box"
            matTooltipPosition="above"
            [matTooltip]="'upsell_page.builder.tooltip_system_text' | transloco"
          ></span>
        </div>
      </div>

      <div class="config-body" [@expandCollapse]="sectionOpen.language">
        <div *ngIf="sectionOpen.language">
          <div class="config-control" *ngIf="form.get('locale'); let control">
            <label>{{ 'upsell_page.builder.design_language' | transloco }}</label>
            <ng-select
              bindValue="value"
              bindLabel="title"
              [clearable]="false"
              [searchable]="false"
              formControlName="locale"
              class="h-46"
              [items]="languageOptions"
              appendTo="body"
              (change)="updatePreviewParams('locale')"
            ></ng-select>
          </div>

          <div class="Translation-Examples" *ngIf="form.get('locale').value !== 'en'">
            <div class="ExampleItem">
              <div class="ExampleItem__Code">Pay Now</div>
              <div class="ExampleItem__Result">{{ 'Pay Now' | translateUpsell:(form.get('locale')?.value || 'en')}}</div>
              <img src="/app_assets/icons/change-icon.svg" alt="">
            </div>
          </div>

          <div class="mt-2">
            <small>
              {{ 'upsell_page.builder.design_header_footer_note' | transloco }}
            </small>
          </div>
        </div>
      </div>
    </div>
    <!-- Callout Banner -->
    <div class="config">
      <div class="config-head _hoverable"
            [class._closed]="!sectionOpen.banner"
            (click)="sectionOpen.banner = !sectionOpen.banner">
        <one-icon class="mr-2" name="chevron-down" [class._rotated]="sectionOpen.banner"></one-icon>
        {{ 'upsell_page.builder.design_callout_banner' | transloco }}
      </div>
      <div class="config-body" [@expandCollapse]="sectionOpen.banner">
        <div *ngIf="sectionOpen.banner">
          <div class="config-control" *ngIf="form.get('banner_title'); let control">
            <label>{{ 'upsell_page.builder.design_title' | transloco }}</label>
            <input
              oneAI
              [topLabelMargin]="2"
              formControlName="banner_title"
              type="text"
              class="form-control"
              (aiText)="updatePreviewParams('banner_title')"
              (input)="updatePreviewParams('banner_title')">
            <ng-container *ngIf="control.errors && control.dirty">
              <small *ngIf="control?.errors['required']" class="text-danger">
                {{ 'upsell_page.builder.val_banner_required' | transloco }}
              </small>
              <small *ngIf="control?.errors['maxlength']" class="text-danger">
                {{ 'upsell_page.builder.val_max_chars' | transloco: { max: control.errors.maxlength.requiredLength } }}
              </small>
              <small *ngIf="control?.errors['space_only']" class="text-danger">
                {{ 'upsell_page.builder.val_not_spaces_only' | transloco }}
              </small>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <!-- Countdown Timer -->
    <div class="config">
      <div class="config-head _hoverable"
            [class._closed]="!sectionOpen.countdown"
            (click)="sectionOpen.countdown = !sectionOpen.countdown && form.get('timer_enabled')?.value">
        <one-icon class="mr-2" name="chevron-down" [class._rotated]="sectionOpen.countdown"></one-icon>
        <div class="d-flex align-items-center justify-content-between w-100">
          {{ 'upsell_page.builder.design_countdown' | transloco }}
          <div *ngIf="form.get('timer_enabled'); let control">
            <pf-switch-box formControlName="timer_enabled"
              [labelInside]="true"
              (change)="onCountdownTimerToggle($event)"
              [labelOff]="'campaign_plugins.common.off' | transloco"
            ></pf-switch-box>
          </div>
        </div>
      </div>
      <div class="config-body" [@expandCollapse]="sectionOpen.countdown">
        <ng-container *ngIf="sectionOpen.countdown && form.get('timer_enabled')?.value">
          <div class="config-control" *ngIf="form.get('timer_text'); let control">
            <label>{{ 'upsell_page.builder.design_timer_text' | transloco }}</label>
            <input
              oneAI
              [topLabelMargin]="2"
              formControlName="timer_text"
              type="text"
              class="form-control"
              (aiText)="updatePreviewParams('timer_text')"
              (input)="updatePreviewParams('timer_text')">
            <ng-container *ngIf="control.errors && control.dirty">
              <small *ngIf="control?.errors['required']" class="text-danger">
                {{ 'upsell_page.builder.val_countdown_required' | transloco }}
              </small>
              <small *ngIf="control?.errors['maxlength']" class="text-danger">
                {{ 'upsell_page.builder.val_max_chars' | transloco: { max: control.errors.maxlength.requiredLength } }}
              </small>
              <small *ngIf="control?.errors['space_only']" class="text-danger">
                {{ 'upsell_page.builder.val_not_spaces_only' | transloco }}
              </small>
            </ng-container>
          </div>

          <div class="config-control" *ngIf="form.get('timer'); let control">
            <label>{{ 'upsell_page.builder.design_time' | transloco }}</label>
            <div class="input-group">
              <input
                class="form-control"
                formControlName="timer"
                type="number"  min="1" max="10"
                (input)="updatePreviewParams('timer')">
              <div class="input-group-append">
                <span class="input-group-text">{{ 'upsell_page.builder.design_mins_suffix' | transloco }}</span>
              </div>
            </div>
            <ng-container *ngIf="control.errors && control.dirty">
              <small *ngIf="control?.errors['required']" class="text-danger">
                {{ 'upsell_page.builder.val_timer_required' | transloco }}
              </small>
              <small class="text-danger mb-1" *ngIf="control.errors.min">
                {{ 'upsell_page.builder.val_gt_zero' | transloco }}
              </small>
              <small class="text-danger mb-1" *ngIf="control.errors.max">
                {{ 'upsell_page.builder.val_timer_over' | transloco: { max: control.errors.max?.max } }}
              </small>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </div>

    <!-- Image View -->
    <div class="config">
      <div class="config-head _hoverable"
            [class._closed]="!sectionOpen.image"
            (click)="sectionOpen.image = !sectionOpen.image">
        <one-icon class="mr-2" name="chevron-down" [class._rotated]="sectionOpen.image"></one-icon>
        {{ 'upsell_page.builder.design_product_image' | transloco }}
      </div>

      <div class="config-body" [@expandCollapse]="sectionOpen.image">
        <div *ngIf="sectionOpen.image">
          <div class="config-control" *ngIf="form.get('image_view'); let control">
            <label>{{ 'upsell_page.builder.design_layout' | transloco }}</label>
            <ng-select
              bindValue="value"
              bindLabel="label"
              [clearable]="false"
              [searchable]="false"
              class="h-46"
              formControlName="image_view"
              [items]="imageViewOptions"
              (change)="updatePreviewParams('image_view')"
              appendTo="body"
            ></ng-select>
            <small>
              {{ 'upsell_page.builder.hint_image_layouts' | transloco }}
            </small>
          </div>
        </div>
      </div>
    </div>

    <!-- Fulfillment Hold Timer -->
    <div class="config" *ngIf="!form.get('timer_enabled')?.value">
      <div class="config-head _hoverable"
            [class._closed]="!sectionOpen.hold_timer"
            (click)="sectionOpen.hold_timer = !sectionOpen.hold_timer">
        <one-icon class="mr-2" name="chevron-down" [class._rotated]="sectionOpen.hold_timer"></one-icon>
        {{ 'upsell_page.builder.design_hold_timer' | transloco }}
      </div>
      <div class="config-body" [@expandCollapse]="sectionOpen.hold_timer">
        <div *ngIf="sectionOpen.hold_timer">
          <p class="config-description mt-3">
            {{ 'upsell_page.builder.hold_timer_intro' | transloco }}
          </p>
          <p class="config-description">
            {{ 'upsell_page.builder.hold_timer_lift' | transloco }}
          </p>
          <div class="config-control" *ngIf="form.get('hold_timer_enabled'); let control">
            <fieldset class="d-flex align-items-center justify-content-between">
              <span class="switchbox-label">
                {{ 'upsell_page.builder.hold_force_lift' | transloco }}
              </span>
              <pf-switch-box formControlName="hold_timer_enabled"
                [labelInside]="true"
                [labelOff]="'campaign_plugins.common.off' | transloco"
              ></pf-switch-box>
            </fieldset>
          </div>

          <ng-container *ngIf="form.get('hold_timer_enabled')?.value">
            <div class="config-control" *ngIf="form.get('hold_timer_value'); let control">
              <label>{{ 'upsell_page.builder.hold_timer_label' | transloco }}</label>
              <ng-select
                bindValue="value"
                bindLabel="label"
                [clearable]="false"
                [searchable]="false"
                formControlName="hold_timer_value"
                class="h-46"
                [items]="holdTimerOptions"
                appendTo="body"
              ></ng-select>
            </div>
          </ng-container>
        </div>
      </div>
    </div>

    <!-- Product Title -->
    <div class="config">
      <div class="config-head _hoverable"
        [class._closed]="!sectionOpen.title"
        (click)="sectionOpen.title = !sectionOpen.title">
        <one-icon class="mr-2" name="chevron-down" [class._rotated]="sectionOpen.title"></one-icon>
        {{ 'upsell_page.builder.design_product_title' | transloco }}
      </div>
      <div class="config-body" [@expandCollapse]="sectionOpen.title">
        <div *ngIf="sectionOpen.title" class="config-control">
          <label>{{ 'upsell_page.builder.design_title_format' | transloco }}</label>
          <input
            [value]="('upsell_page.builder.design_original_title' | transloco)"
            type="text"
            class="form-control"
            disabled="true"/>
          <span class="Tooltip _local-input-tooltip"
                matTooltipClass="Tooltip-Box"
                matTooltipPosition="above"
                [matTooltip]="'upsell_page.builder.tooltip_no_edit_title' | transloco"
          ></span>
          <small>
            {{ 'upsell_page.builder.hint_full_title' | transloco }}
          </small>
        </div>
      </div>
    </div>

    <!-- Product Price -->
    <div class="config">
      <div class="config-head _hoverable"
            [class._closed]="!sectionOpen.savings"
            (click)="sectionOpen.savings = !sectionOpen.savings">
        <one-icon class="mr-2" name="chevron-down" [class._rotated]="sectionOpen.savings"></one-icon>
        {{ 'upsell_page.builder.design_product_price' | transloco }}
      </div>
      <div class="config-body" [@expandCollapse]="sectionOpen.savings">
        <div *ngIf="sectionOpen.savings">
          <div class="config-control" *ngIf="form.get('label'); let control">
            <fieldset class="d-flex align-items-center justify-content-between">
              <span class="switchbox-label">
                {{ 'upsell_page.builder.show_savings_label' | transloco }}
              </span>
              <pf-switch-box formControlName="label"
                [labelInside]="true"
                (change)="onSavingsLabelToggle($event)"
                [labelOff]="'campaign_plugins.common.off' | transloco"
              ></pf-switch-box>
            </fieldset>
          </div>
        </div>
      </div>
    </div>

    <!-- Product Description -->
    <div class="config">
      <div class="config-head _hoverable"
            [class._closed]="!sectionOpen.description"
            (click)="sectionOpen.description = !sectionOpen.description">
        <one-icon class="mr-2" name="chevron-down" [class._rotated]="sectionOpen.description"></one-icon>
        {{ 'upsell_page.builder.design_product_description' | transloco }}
      </div>
      <div class="config-body" [@expandCollapse]="sectionOpen.description">
        <div *ngIf="sectionOpen.description">
          <div class="config-control" *ngIf="form.get('description_format'); let control">
            <label>{{ 'upsell_page.builder.description_format' | transloco }}</label>
            <ng-select
              bindValue="value"
              bindLabel="label"
              [clearable]="false"
              [searchable]="false"
              formControlName="description_format"
              class="h-46"
              [items]="descriptionFormatOptions"
              appendTo="body"
              (change)="onDescriptionFormatChange()"
            ></ng-select>
            <small *ngIf="control.value === upsellFormatType.Default">
              {{ 'upsell_page.builder.hint_whole_desc' | transloco }}
            </small>
          </div>
          <div class="config-control" *ngIf="form.get('description_format')?.value === upsellFormatType.Custom && form.get('description_custom'); let control">
            <label>{{ 'upsell_page.builder.custom_description' | transloco }}</label>
            <quill-editor [placeholder]="'upsell_page.builder.placeholder_description' | transloco" [modules]="editorConfig"
                          formControlName="description_custom">
            </quill-editor>
            <ng-container *ngIf="control.errors && control.dirty">
              <small *ngIf="control?.errors['required']" class="text-danger">
                {{ 'upsell_page.builder.val_desc_required' | transloco }}
              </small>
              <small *ngIf="control?.errors['maxlength']" class="text-danger">
                {{ 'upsell_page.builder.val_max_chars' | transloco: { max: control.errors.maxlength.requiredLength } }}
              </small>
              <small *ngIf="control?.errors['space_only']" class="text-danger">
                {{ 'upsell_page.builder.val_not_spaces_only' | transloco }}
              </small>
            </ng-container>
          </div>
          <div class="config-control" *ngIf="[upsellFormatType.Truncated, upsellFormatType.Custom].includes(form.get('description_format')?.value) && form.get('description_length'); let control">
            <div>
              {{ 'upsell_page.builder.truncate_after' | transloco }}
              <input class="form-control _local-mini-stepper"
                    formControlName="description_length"
                    type="number"  min="1" max="500"
                    (input)="updatePreviewParams('description_length')">
              {{ form.get('description_format')?.value === upsellFormatType.Truncated ? ('upsell_page.builder.chars_word' | transloco) : ('upsell_page.builder.paragraphs_word' | transloco) }}
            </div>
            <ng-container *ngIf="control.errors && control.dirty">
              <small *ngIf="control?.errors['required']" class="text-danger">
                {{ 'upsell_page.builder.val_length_required' | transloco }}
              </small>
              <small class="text-danger mb-1" *ngIf="control.errors.min">
                {{ 'upsell_page.builder.val_gt_zero' | transloco }}
              </small>
              <small class="text-danger mb-1" *ngIf="control.errors.max">
                {{ 'upsell_page.builder.val_length_max' | transloco: { max: control.errors.max?.max } }}
              </small>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <!-- Product Quantity Selector -->
    <div class="config">
      <div class="config-head _hoverable"
            [class._closed]="!sectionOpen.quantity"
            (click)="sectionOpen.quantity = !sectionOpen.quantity">
        <one-icon class="mr-2" name="chevron-down" [class._rotated]="sectionOpen.quantity"></one-icon>
        {{ 'upsell_page.builder.design_quantity_selector' | transloco }}
      </div>
      <div class="config-body" [@expandCollapse]="sectionOpen.quantity">
        <div *ngIf="sectionOpen.quantity">
          <div class="config-control" *ngIf="form.get('predefined_quantity'); let control">
            <fieldset class="d-flex align-items-center justify-content-between">
              <span class="switchbox-label">
                {{ 'upsell_page.builder.predefined_quantity' | transloco }}
                <span class="Tooltip"
                      matTooltipClass="Tooltip-Box"
                      matTooltipPosition="above"
                      [matTooltip]="'upsell_page.builder.tooltip_predefined_qty' | transloco">
                </span>
              </span>
              <pf-switch-box formControlName="predefined_quantity"
                [labelInside]="true"
                (change)="onPredefinedQuantityToggle($event)"
                [labelOff]="'campaign_plugins.common.off' | transloco"
              ></pf-switch-box>
            </fieldset>
          </div>

          <ng-container *ngIf="form.get('predefined_quantity')?.value">
            <div class="config-control" *ngIf="form.get('quantity'); let control">
              <label>{{ 'upsell_page.builder.quantity' | transloco }}</label>
              <input
                formControlName="quantity"
                type="number"
                class="form-control"
                (input)="updatePreviewParams('quantity')">
              <ng-container *ngIf="control.errors && control.dirty">
                <small *ngIf="control?.errors['required']" class="text-danger">
                  {{ 'upsell_page.builder.val_qty_required' | transloco }}
                </small>
                <small class="text-danger mb-1" *ngIf="control.errors.min">
                  {{ 'upsell_page.builder.val_gt_zero' | transloco }}
                </small>
                <small class="text-danger mb-1" *ngIf="control.errors.max">
                  {{ 'upsell_page.builder.val_qty_over' | transloco: { max: control.errors.max?.max } }}
                </small>
              </ng-container>
            </div>
          </ng-container>
        </div>
      </div>
    </div>

    <!-- Product Shipping -->
    <div class="config">
      <div class="config-head _hoverable"
            [class._closed]="!sectionOpen.shipping"
            (click)="sectionOpen.shipping = !sectionOpen.shipping">
        <one-icon class="mr-2" name="chevron-down" [class._rotated]="sectionOpen.shipping"></one-icon>
        {{ 'upsell_page.builder.design_product_shipping' | transloco }}
      </div>
      <div class="config-body" [@expandCollapse]="sectionOpen.shipping">
        <div *ngIf="sectionOpen.shipping">
          <div class="config-control" *ngIf="form.get('shipping_type'); let control">
            <label>{{ 'upsell_page.builder.shipping' | transloco }}</label>
            <ng-select
              bindValue="value"
              bindLabel="label"
              [clearable]="false"
              [searchable]="false"
              formControlName="shipping_type"
              class="h-46"
              [items]="shippingTypeOptions"
              appendTo="body"
              (change)="onShippingTypeChange()"
            ></ng-select>
          </div>
          <div class="config-control" *ngIf="form.get('shipping_type')?.value === upsellShippingType.Fixed && form.get('shipping_amount'); let control">
            <label>{{ 'upsell_page.builder.shipping_rate' | transloco }}</label>
            <input class="form-control"
                  formControlName="shipping_amount"
                  type="number" min="0" max="9999999" step="1"
                  (input)="updatePreviewParams('shipping_amount')">
            <ng-container *ngIf="control.errors && control.dirty">
              <small *ngIf="control?.errors['required']" class="text-danger">
                {{ 'upsell_page.builder.val_shipping_required' | transloco }}
              </small>
              <small class="text-danger mb-1" *ngIf="control.errors.min">
                {{ 'upsell_page.builder.val_gt_zero' | transloco }}
              </small>
              <small class="text-danger mb-1" *ngIf="control.errors.max">
                {{ 'upsell_page.builder.val_qty_over' | transloco: { max: control.errors.max?.max } }}
              </small>
            </ng-container>
          </div>
          <div class="form-group mt-3 mb-0" *ngIf="form.get('shipping_type')?.value === upsellShippingType.Fixed && form.get('shipping_per_unit'); let control">
            <label class="d-flex align-items-center">
              <mat-checkbox formControlName="shipping_per_unit" (change)="updatePreviewParams('shipping_per_unit')" class="mr-2"></mat-checkbox>
              {{ 'upsell_page.builder.charge_per_unit' | transloco }}
              <span class="Tooltip"
                    matTooltipClass="Tooltip-Box"
                    matTooltipPosition="above"
                    [matTooltip]="'upsell_page.builder.tooltip_charge_per_unit' | transloco"></span>
            </label>
          </div>
        </div>
      </div>
    </div>

    <!-- One-Click Checkout Buttons -->
    <div class="config">
      <div class="config-head _hoverable"
            [class._closed]="!sectionOpen.buttons"
            (click)="sectionOpen.buttons = !sectionOpen.buttons">
        <one-icon class="mr-2" name="chevron-down" [class._rotated]="sectionOpen.buttons"></one-icon>
        {{ 'upsell_page.builder.design_one_click_buttons' | transloco }}
      </div>
      <div class="config-body" [@expandCollapse]="sectionOpen.buttons">
        <div *ngIf="sectionOpen.buttons">
          <div class="config-control" *ngIf="form.get('accept_button_text'); let control">
            <label>{{ 'upsell_page.builder.accept_button' | transloco }}</label>
            <ng-select
              bindValue="value"
              bindLabel="label"
              [clearable]="false"
              [searchable]="false"
              formControlName="accept_button_text"
              class="h-46"
              [items]="acceptButtonOptions"
              appendTo="body"
              (change)="updatePreviewParams('accept_button_text')"
            >
              <ng-template ng-label-tmp let-item="item">
                {{item.label | translateUpsell:(form.get('locale')?.value || 'en')}}
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                {{item.label | translateUpsell:(form.get('locale')?.value || 'en')}}
              </ng-template>
            </ng-select>
          </div>
          <div class="config-control" *ngIf="form.get('decline_button_text'); let control">
            <label>{{ 'upsell_page.builder.decline_button' | transloco }}</label>
            <ng-select
              bindValue="value"
              bindLabel="label"
              [clearable]="false"
              [searchable]="false"
              formControlName="decline_button_text"
              class="h-46"
              [items]="declineButtonOptions"
              appendTo="body"
              (change)="updatePreviewParams('decline_button_text')"
            >
              <ng-template ng-label-tmp let-item="item">
                {{item.label | translateUpsell:(form.get('locale')?.value || 'en')}}
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                {{item.label | translateUpsell:(form.get('locale')?.value || 'en')}}
              </ng-template>
            </ng-select>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
